import { setEncryptedEncryptionKey, getEncryptedEncryptionKey, removeEncryptedEncryptionKey } from '@/utils/services'
import { calculateClientKey, generateEncryptionKey, encrypt, decrypt } from '@/utils/crypto'

const state = {
  encryptedEncryptionKey: null,
  encryptionKey: null,
  clientKey: null
}

const mutations = {
  setEncryptedEncryptionKey(state, encryptedEncryptionKey) {
    state.encryptedEncryptionKey = encryptedEncryptionKey
  },
  setEncryptionKey(state, encryptionKey) {
    state.encryptionKey = encryptionKey
  },
  setClientKey(state, clientKey) {
    state.clientKey = clientKey
  }
}

const actions = {
  async getKeys({ dispatch, rootState }) {
    const userUid = rootState.user ? rootState.user.uid : null
    if (userUid) {
      // await dispatch('setClientKey', localStorage.getItem('clientKey'))
      await dispatch('getClientKey', userUid)
      await dispatch('getEncryptionKey', userUid)
    }
  },
  async getEncryptionKey({ commit, dispatch, state: { clientKey } }, userUid) {
    const encryptedEncryptionKey = await getEncryptedEncryptionKey(userUid)
    commit('setEncryptedEncryptionKey', encryptedEncryptionKey)
    try {
      const encryptionKey = decrypt(encryptedEncryptionKey, clientKey)
      commit('setEncryptionKey', encryptionKey)
      return encryptionKey
    } catch (e) {
      await dispatch('removeClientKey')
      return null
    }
  },
  async getClientKey({ commit }, userUid) {
    const clientKeys = getClientKeysFromLocalStorage()
    const clientKey = clientKeys[userUid]
    commit('setClientKey', clientKey)
    return clientKey
  },
  async setClientKey({ commit }, { clientKey, userUid }) {
    if (clientKey) {
      const clientKeys = getClientKeysFromLocalStorage()
      clientKeys[userUid] = clientKey
      localStorage.setItem('clientKeys', JSON.stringify(clientKeys))
      commit('setClientKey', clientKey)
    }
    return true
  },
  async removeClientKey({ commit }, userUid) {
    const clientKeys = getClientKeysFromLocalStorage()
    delete clientKeys[userUid]
    localStorage.setItem('clientKeys', JSON.stringify(clientKeys))
    commit('setClientKey', null)
    return true
  },
  async enableEncryption({ rootState, commit, dispatch }, passphrase) {
    const userUid = rootState.user ? rootState.user.uid : null
    const encryptionKey = generateEncryptionKey()
    const clientKey = calculateClientKey(passphrase)
    await dispatch('setClientKey', { clientKey, userUid })
    const encryptedEncryptionKey = encrypt(encryptionKey, clientKey)
    await setEncryptedEncryptionKey(userUid, encryptedEncryptionKey)
    commit('setEncryptionKey', encryptionKey)
    dispatch('syncNotes', rootState.notes, { root: true })
  },
  async disableEncryption({ state, rootState, commit, dispatch }) {
    const { encryptionKey } = state
    const { user, notes } = rootState
    const userUid = user ? user.uid : null
    if (encryptionKey) {
      await removeEncryptedEncryptionKey(userUid)
      commit('setEncryptedEncryptionKey', null)
      commit('setEncryptionKey', null)
      await dispatch('removeClientKey', userUid)
      dispatch('syncNotes', notes, { root: true })
    }
  }
}

const getters = {
  promptForPassphrase: state => state.encryptedEncryptionKey && !state.clientKey
}

function getClientKeysFromLocalStorage() {
  try {
    return JSON.parse(localStorage.getItem('clientKeys')) || {}
  } catch (e) {
    return {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
